import { StyleProps } from '$/components/ui';
import { IoradIcon } from '$/images/Icons';
import { yupIsValidUrl } from '$/utils/isUrl';
import React from 'react';
import * as yup from 'yup';
import { HandoutInfo } from '../Handout/HandoutInfo';
import { AnalyticsCardProps } from '../cards/types';
import {
  InteractionAccordionPanelProps,
  InteractionModalAccordionsHook,
  InteractionModalComponentProps,
  ModalValidationRules,
} from '../types';
import { IoradCardBody } from './IoradCard';

import {
  AttendeeFragment,
  InteractionForAttendeeFragment,
  InteractionFragment,
} from '$/GraphQL/schema/types';
import { PublicEWebinarFragment } from '$/shared/typesProxy';
import type { InteractionEditableValues } from '../Modals/InteractionModal';

import Form from '$/components/ui/Form';

const AnalyticsIoradCard = React.lazy(() => import('./AnalyticsIoradCard'));
const IoradSettingsAccordion = React.lazy(() => import('./IoradSettings'));
const IoradModal = React.lazy(() => import('./IoradModal'));

const IoradSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = () => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: { content: <IoradSettingsAccordion /> },
    },
  ];
};

export class IoradLinkInfo extends HandoutInfo {
  public constructor(
    i: InteractionForAttendeeFragment | InteractionFragment,
    ewebinar?: PublicEWebinarFragment,
    attendee?: AttendeeFragment
  ) {
    super(i, ewebinar, attendee);
  }

  public typeName(): string | undefined {
    return 'Iorad tutorial';
  }

  public modalValidationRules(): ModalValidationRules {
    return {
      ...super.modalValidationRules(),

      description: yup.string(),
      buttonText: yup.string().trim().required(),
      link: yupIsValidUrl(),
    };
  }

  public async onSave(values: InteractionEditableValues): Promise<InteractionEditableValues> {
    const submitValues = { ...values };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    delete (submitValues as any).extensionStatus;

    return submitValues;
  }

  public category(): 'Standard' | 'Special' | 'Anchor' | 'Conversion' {
    return 'Special';
  }

  public userCanAdd(): boolean {
    return true;
  }

  public icon(): React.FC<StyleProps> {
    return IoradIcon;
  }

  public useModalPreviewComponent(): React.LazyExoticComponent<
    React.FC<InteractionModalComponentProps>
  > | null {
    return IoradModal;
  }

  public modalSettingsAccordions(): InteractionModalAccordionsHook | null {
    return IoradSettings;
  }

  public analyticsCardComponent(): React.LazyExoticComponent<React.FC<AnalyticsCardProps>> {
    return AnalyticsIoradCard;
  }

  public cardBodyComponent(): React.FC {
    return IoradCardBody;
  }
}
